module.exports = {
    // "apiUrl": (process.env.NODE_ENV !== "production") ? (`${window.location.protocol}//${window.location.hostname}:2112`) : ("https://dev.do-event.com:21121"),
    "apiUrl": "https://perizinan.jombangkab.go.id/?",
    "perpage" : 30,
    "key" : "fac6bf92dd997c72f16ad1b6bffa9bef"
};
